import { render } from "./LessonsBulkMoveDialog.vue?vue&type=template&id=00fb60fb&scoped=true"
import script from "./LessonsBulkMoveDialog.vue?vue&type=script&lang=js"
export * from "./LessonsBulkMoveDialog.vue?vue&type=script&lang=js"

import "./LessonsBulkMoveDialog.vue?vue&type=style&index=0&id=00fb60fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00fb60fb"]])

export default __exports__